import isPopupAssignedToCurrentSigner from './isPopupAssignedToCurrentSigner';

/**
 * Return a list of signature popups filtered by the current
 * signing address.  If activePopup is provided, it is included
 * in results no matter what (for purposes of navigation sorting).
 * @param popups (array or object of popups)
 * @param activePopup (optional string)
 * @returns {unknown[]}
 */
const filterByCurrentSigner = (popups, activePopup = null) =>
  Object.values(popups)
    .filter(popup => popup.id === activePopup || isPopupAssignedToCurrentSigner(popup));

export default filterByCurrentSigner;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/filterByCurrentSigner.jsx